
export const CLASS_SHARE_DIALOG_ITEM = 'sharing-dialog-item';
export const SHARE_DIALOG_USERPICS_MAX = 6;
